export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // open kulutusluotto page on mobile nav
    $('.navigation.mobile .menu-item-42').addClass('is-open');

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js